import React from 'react';
import { FlexDiv } from '../../../design-system/containers';
import { useTranslation } from 'react-i18next';
import { rgba } from 'polished';
import { palette } from '../../../design-system/colors';
import { TextDefault } from '../../../design-system/texts';

export default function DecisionOverlayMobile({
    decisionQuestion,
    onAnswer,
    isAtEnd,
}) {
    const { t } = useTranslation();

    const madeDecision = (decision) => {
        onAnswer(decisionQuestion.id, decision);
    };

    return (
        !isAtEnd && (
            <FlexDiv
                backgroundColor={rgba(palette.graphite.heavyMetal, 0.1)}
                fullWidth
                gap={16}
                padding={24}
                column
                mobileOnly
            >
                <FlexDiv
                    link
                    onClick={() => madeDecision(decisionQuestion.decision_1)}
                    fullWidth
                    justifyCenter
                    alignCenter
                    backgroundColor={palette.graphite.white}
                    borderRadius={4}
                >
                    <TextDefault my={16}>
                        {t(decisionQuestion.decision_1.text)}
                    </TextDefault>
                </FlexDiv>
                <FlexDiv
                    link
                    onClick={() => madeDecision(decisionQuestion.decision_2)}
                    fullWidth
                    justifyCenter
                    alignCenter
                    backgroundColor={palette.graphite.white}
                    borderRadius={4}
                >
                    <TextDefault my={16}>
                        {t(decisionQuestion.decision_2.text)}
                    </TextDefault>
                </FlexDiv>
            </FlexDiv>
        )
    );
}
